import linegraph from '../../../../components/linegraph.vue'
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import * as echarts from "echarts";
import moment from 'moment';
import { domainName } from "../../../../utility/index"

export default {
    data() {
        return {
            titles: [],
            line: ["line1", "line2", "line3", "line4"],
            oneDown: ["oneDown1", "oneDown2", "oneDown3", "oneDown4"],
            oneUp: ["oneUp1", "oneUp2", "oneUp1", "oneUp2"],
            dialogOperateFormVisible: false,
            OperateTitle: '',
            btnType: '',
            operatesList: [],
            operatesHeight: '350px',
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false,
                mutiSelect: false, 
                serialNumber: true,
            },
            allColumns: [],
            proportionColumns: [
                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                },
                {
                    prop: "carCount",
                    label: this.$t('GovernmentRegulation.carCount'),
                    align: "center",

                },
                {
                    prop: "driverCount",
                    label: this.$t('GovernmentRegulation.driverCount'),
                    align: "center",
                },
                {
                    prop: "driverCarRate",
                    label: this.$t('GovernmentRegulation.driverCarRate'),
                    align: "center",
                },
            ],
            deviceColumns: [
                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                },
                {
                    prop: "carCount",
                    label: this.$t('GovernmentRegulation.carCount'),
                    align: "center",

                },
                {
                    prop: "linkCarCount",
                    label: this.$t('GovernmentRegulation.linkCarCount'),
                    align: "center",
                },
                {
                    prop: "onLinkCarCount",
                    label: this.$t('GovernmentRegulation.onLinkCarCount'),
                    align: "center",
                },
            ],
            allOperates: {
                width: 100,
                fixed: "right",
                list: [
                    
                ],
            },
            OperatesCurrentPage: 1,
            OperatesPageSize: 10,
            OperatesTotal: 1,
            emissionOption: {},
            secureOption: {},
            ageOption: {},
            maintenanceOption: {},
            checkOption: {},
            abnormalOption: {}
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getData()
        this.getEmission()
        this.getSecure()
        this.getAge()
        this.getMaintenance()
        this.getCheck()
        this.getAbnormal()
    },
    methods: {
        getData() {
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch('JurisdictionalAnalysis/GET_GETJURISDICTIONSURVEY', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.titles = res.data.data
                        res.data.data.map(item => {
                            item.count = String(item.count)
                        })
                    }
                }
            }).catch(err => { })
        },
        btnTitle(title) {
            console.log(title)
            if (title.isClick == 1) {
                this.dialogOperateFormVisible = true
                this.OperateTitle = this.$t('GovernmentRegulation.InsufficientManMachineRatio')
                this.btnType = "proportion"
                this.allColumns = this.proportionColumns
            } else if (title.isClick == 3) {
                this.dialogOperateFormVisible = true
                this.OperateTitle = this.$t('GovernmentRegulation.SuspectedEquipmentRemoval')
                this.btnType = "device"
                this.allColumns = this.deviceColumns
            }
            this.getOperateList()
        },
        getOperateList() {
            if (this.btnType == "proportion") {
                let param = {
                    jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                }
                this.$store.dispatch('JurisdictionalAnalysis/GET_GETDRIVERCARRATE', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.operatesList = res.data.data.list
                            this.$refs.OperatesPage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            } else {
                let param = {
                    jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                }
                this.$store.dispatch('JurisdictionalAnalysis/GET_GETDEVICEDISMANTLE', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.operatesList = res.data.data.list
                            this.$refs.OperatesPage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            }
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        changeOperatesSize(item) {
            this.OperatesPageSize = item.pageSize
            this.OperatesCurrentPage = item.pageNum
            this.getOperateList()
        },
        down() {
            if (this.btnType == "proportion") {
                let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportDriverCarRate?jurisdictionNum=${jurisdictionNum}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportDriverCarRate?jurisdictionNum=${jurisdictionNum}`
                        location.href = url
                    }
                }
            } else {
                let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportDeviceDismantle?jurisdictionNum=${jurisdictionNum}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportDeviceDismantle?jurisdictionNum=${jurisdictionNum}`
                        location.href = url
                    }
                }
            }
        },

        getEmission() {
            let emissionData = []
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETCAREMISSIONRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            res.data.data.map(item => {
                                emissionData.push({
                                    value: item.carCount,
                                    name: item.emissionType
                                })
                            })
                            this.emission(emissionData)
                        }
                    }
                }
            }).catch(err => {
            })
        },
        emission(emissionData) {
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    right: "2%",
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff",
                        height: 10,
                    },
                },
                series: [
                    {
                        name: this.$t('GovernmentRegulation.emissionRatio'),
                        type: "pie",
                        radius: [15, 100],
                        center: ["40%", "50%"],
                        roseType: "area",
                        itemStyle: {
                            borderRadius: 8,
                        },
                        data: emissionData,
                    },
                ],
            }
            this.emissionOption = option
        },

        getSecure() {
            let secureData = ''
            let unsafeData = ''
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETSAFETYDEVICERATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        secureData = res.data.data.safetyCarCount
                        unsafeData = res.data.data.noSafetyCarCount
                        this.secure(secureData,unsafeData)
                    }
                }
            }).catch(err => {
            })
        },
        secure(secureData,unsafeData) {
            let data = [
                { value: secureData, name: this.$t('GovernmentRegulation.safe') },
                { value: unsafeData, name: this.$t('GovernmentRegulation.noSafe') }
            ]
            let colorList = ["#409EFF", "#FC5B62"]
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    right: "2%",
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff",
                    },
                },
                series: [
                    {
                        name: this.$t('GovernmentRegulation.safeEquiteRatio'),
                        type: "pie",
                        radius: ["43%", "68%"],
                        center: ["40%", "50%"],
                        label: {
                            formatter: "{b}:{d}%",
                        },
                        data: data.map((item, index) => {
                            item.label = {
                                color: colorList[index],
                            };
                            return item;
                        }),
                        itemStyle: {
                            color: (params) => {
                                var index = params.dataIndex;
                                return colorList[index];
                            },
                            emphasis: {
                                shadowBlur: 5,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0)'
                            },
                            borderColor: "#081831",
                            borderWidth: '1',
                        },
                    },
                ],
            }
            this.secureOption = option
        },

        getAge() {
            let date = []
            let carRate = []
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETCARAGERATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            res.data.data.map((item, index) => {
                                date.push(item.carAge)
                                carRate.push(item.carAgeRate)
                            })
                            this.age(date,carRate)
                        } else {
                        }
                    }
                }
            }).catch(err => {
                
            })
        },
        age(date,carRate) {
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    right: "2%",
                    textStyle: {
                        color: "#fff",
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    splitLine: { show: false },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    data: date
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '10%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#fff'
                    },
                    splitLine: {
                        show: true, lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    min: 0,
                }],
                series: [
                    {
                        name: this.$t('GovernmentRegulation.car'),
                        data: carRate,
                        type: "pictorialBar",
                        symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#1E89F8' },                   
                                        { offset: 1, color: '#4FA4FB' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.ageOption = option
        },

        getMaintenance() {
            let maintainNormalCount = ''
            let maintainApproachCount = ''
            let maintainExpirationCount	 = ''
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETCARMAINTAINRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        maintainNormalCount = res.data.data.maintainNormalCount
                        maintainApproachCount = res.data.data.maintainApproachCount
                        maintainExpirationCount	 = res.data.data.maintainExpirationCount	
                        this.maintenance(maintainNormalCount,maintainApproachCount,maintainExpirationCount)
                    }
                }
            }).catch(err => {
            })
        },
        maintenance(maintainNormalCount,maintainApproachCount,maintainExpirationCount) {
            let data = [
                { value: maintainNormalCount, name: this.$t('GovernmentRegulation.normal') },
                { value: maintainApproachCount, name: this.$t('GovernmentRegulation.nearTime')},
                { value: maintainExpirationCount, name: this.$t('GovernmentRegulation.exceedTime') }
            ]
            let colorList = ["#6CEC86", "#FCD473", "#FC5B62"]
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    right: "2%",
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff",
                    },
                },
                series: [
                    {
                        name: this.$t('GovernmentRegulation.maintenanceRatio'),
                        type: "pie",
                        radius: ["43%", "68%"],
                        center: ["40%", "50%"],
                        label: {
                            formatter: "{b}:{d}%",
                        },
                        data: data.map((item, index) => {
                            item.label = {
                                color: colorList[index],
                            };
                            return item;
                        }),
                        itemStyle: {
                            color: (params) => {
                                var index = params.dataIndex;
                                return colorList[index];
                            },
                            emphasis: {
                                shadowBlur: 5,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0)'
                            },
                            borderColor: "#081831",
                            borderWidth: '1',
                        },
                    },
                ],
            }
            this.maintenanceOption = option
        },

        getCheck() {
            let finishSpotCheckCount = ''
            let unfinishedSpotCheckCount = ''
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETCHECKRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        finishSpotCheckCount = res.data.data.finishSpotCheckCount
                        unfinishedSpotCheckCount = res.data.data.unfinishedSpotCheckCount
                        this.check(finishSpotCheckCount,unfinishedSpotCheckCount)
                    }
                }
            }).catch(err => {
            })
        },
        check(finishSpotCheckCount,unfinishedSpotCheckCount) {
            let data = [
                { value: finishSpotCheckCount, name: this.$t('GovernmentRegulation.checked') },
                { value: unfinishedSpotCheckCount, name: this.$t('GovernmentRegulation.noCheck') }
            ]
            let colorList = ["#409EFF", "#FC5B62"]
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    right: "2%",
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff",
                    },
                },
                series: [
                    {
                        name: this.$t('GovernmentRegulation.checkRatio'),
                        type: "pie",
                        radius: ["43%", "68%"],
                        center: ["40%", "50%"],
                        label: {
                            formatter: "{b}:{d}%",
                        },
                        data: data.map((item, index) => {
                            item.label = {
                                color: colorList[index],
                            };
                            return item;
                        }),
                        itemStyle: {
                            color: (params) => {
                                var index = params.dataIndex;
                                return colorList[index];
                            },
                            emphasis: {
                                shadowBlur: 5,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0)'
                            },
                            borderColor: "#081831",
                            borderWidth: '1',
                        },
                    },
                ],
            }
            this.checkOption = option
        },

        getAbnormal() {
            let normalIsWarning = ''
            let abnormalIsWarning = ''
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
            }
            this.$store.dispatch("JurisdictionalAnalysis/GET_GETSPOTCHECKABNORMALRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        normalIsWarning = res.data.data.normalIsWarning
                        abnormalIsWarning = res.data.data.abnormalIsWarning
                        this.abnormal(normalIsWarning,abnormalIsWarning)
                    }
                }
            }).catch(err => {
            })
        },
        abnormal(normalIsWarning,abnormalIsWarning) {
            let data = [
                { value: normalIsWarning, name: this.$t('GovernmentRegulation.normal') },
                { value: abnormalIsWarning, name: this.$t('GovernmentRegulation.abnormal') }
            ]
            let colorList = ["#409EFF", "#FC5B62"]
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    right: "2%",
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff",
                    },
                },
                series: [
                    {
                        name: this.$t('GovernmentRegulation.checkAbnormalRatio'),
                        type: "pie",
                        radius: ["43%", "68%"],
                        center: ["40%", "50%"],
                        label: {
                            formatter: "{b}:{d}%",
                        },
                        data: data.map((item, index) => {
                            item.label = {
                                color: colorList[index],
                            };
                            return item;
                        }),
                        itemStyle: {
                            color: (params) => {
                                var index = params.dataIndex;
                                return colorList[index];
                            },
                            emphasis: {
                                shadowBlur: 5,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0)'
                            },
                            borderColor: "#081831",
                            borderWidth: '1',
                        },
                    },
                ],
            }
            this.abnormalOption = option
        }
    }
}